import React from 'react';
import { motion } from 'framer-motion';
import { Phone, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section id="inicio" className="relative h-[100svh] min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-76">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-77">
        <img src="https://cdn.magicpatterns.com/uploads/eSVDBbGkcbewYRCWYueyMp/ChatGPT_Image_22_may_2026,_09_05_39_p.m..png" alt="The Happy Taco Food Truck at night" className="w-full h-full object-cover object-center" fetchPriority="high" decoding="async" data-id="element-78" />
        <div className="absolute inset-0 bg-gradient-to-b from-burgundy-dark/60 via-burgundy-dark/40 to-burgundy-dark/90 mix-blend-multiply" data-id="element-79" />
        <div className="absolute inset-0 bg-black/30" data-id="element-80" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center mt-20" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-82">
          <h1 className="font-display font-black text-5xl md:text-7xl lg:text-8xl text-cream leading-[1.1] tracking-tight mb-6 drop-shadow-lg" data-id="element-83">
            COMIDA MEXICANA <br className="hidden md:block" data-id="element-84" />
            <span className="text-orange-light" data-id="element-85">FRESCA Y AUTÉNTICA</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-86">
          <p className="font-script text-3xl md:text-5xl text-cream/90 mb-10 drop-shadow-md" data-id="element-87">
            Servida con amor en cada taco.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-88">
          <a href="tel:+12522131970" className="group flex items-center justify-center gap-3 bg-orange hover:bg-orange-light text-white w-full sm:w-auto px-8 py-4 rounded-full font-bold tracking-wider transition-all shadow-[0_0_20px_rgba(232,115,44,0.4)] hover:shadow-[0_0_30px_rgba(232,115,44,0.6)] hover:-translate-y-1" data-id="element-89">
            <Phone size={20} className="group-hover:rotate-12 transition-transform" data-id="element-90" />
            <span data-id="element-91">LLAMAR AHORA</span>
          </a>
          <a href="#menu" className="group flex items-center justify-center gap-3 bg-transparent border-2 border-cream/80 hover:border-cream text-cream w-full sm:w-auto px-8 py-4 rounded-full font-bold tracking-wider transition-all hover:bg-cream/10" data-id="element-92">
            <span data-id="element-93">VER MENÚ</span>
            <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" data-id="element-94" />
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="mt-12 flex items-center justify-center gap-2 text-cream/80 font-medium tracking-widest" data-id="element-95">
          <Phone size={16} data-id="element-96" />
          <span data-id="element-97">(252) 213-1970</span>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-cream/60" data-id="element-98">
        <span className="text-xs tracking-[0.2em] uppercase font-medium" data-id="element-99">
          Explorar
        </span>
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        repeat: Infinity,
        duration: 1.5,
        ease: 'easeInOut'
      }} className="w-[1px] h-12 bg-gradient-to-b from-cream/60 to-transparent" data-id="element-100" />
      </motion.div>
    </section>;
}